import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import GlobalPrompt from "@/components/Globals/prompt/GlobalPrompt.vue";
import GlobalSnackbar from "@/components/Globals/snackbar/GlobalSnackbar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Globals',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GlobalPrompt),
    _createVNode(GlobalSnackbar)
  ], 64))
}
}

})